import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import hljs from 'highlight.js/lib/core';
import json from 'highlight.js/lib/languages/json';
import protobuf from 'highlight.js/lib/languages/protobuf';
import yaml from 'highlight.js/lib/languages/yaml';

import 'highlight.js/styles/atom-one-dark.css';

hljs.registerLanguage('json', json);
hljs.registerLanguage('yaml', yaml);
hljs.registerLanguage('protobuf', protobuf);

export type CodeLanguage = 'json' | 'yaml' | 'protobuf';

interface CodeBlockProps {
    code: string;
    language: CodeLanguage;
    minHeight?: number;
    maxHeight?: number;
}

const CodeBlock = ({ code, language, minHeight = 250, maxHeight = 500 }: CodeBlockProps) => {
    const intl = useIntl();

    const highlighted = useMemo(() => {
        if (!code) return '';
        return hljs.highlight(code, { language }).value;
    }, [code, language]);

    return (
        <pre
            className="margin-0 overflow-auto"
            style={{ minHeight, maxHeight, border: 'none', backgroundColor: '#282c34' }}
        >
            {code ? (
                <code
                    className={`hljs language-${language}`}
                    style={{ display: 'block', minHeight, borderRadius: 4 }}
                    dangerouslySetInnerHTML={{ __html: highlighted }}
                />
            ) : (
                <code className="hljs" style={{ display: 'block', minHeight, borderRadius: 4 }}>
                    {intl.formatMessage({ id: 'intl-msg:codeBlock.noContent' })}
                </code>
            )}
        </pre>
    );
};

export default CodeBlock;
